import { Box, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import Stepper from '@components/Stepper';
import { useBookPageContext } from '@utils/context/book';

const FirstPage: FC = () => {
    const { t } = useTranslation('books');
    const { asPath } = useRouter();
    const { bookData } = useBookPageContext();
    const { content } = bookData;

    const firstContent = content?.[0];

    const steps = {
        first: {
            active: false,
            label: t('firstPage.steps.category'),
            number: 1,
        },
        second: {
            active: false,
            label: t('firstPage.steps.sheet'),
            number: 2,
        },
        third: {
            active: false,
            label: t('firstPage.steps.download'),
            number: 3,
        },
    };

    return (
        <Box alignItems="center" display="flex" flexDirection="column">
            <Stepper
                steps={steps}
                stepsContainerSx={{
                    flexDirection: {
                        md: 'row',
                        xs: 'column',
                    },
                    mt: 2,
                }}
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    mt: {
                        md: 17,
                    },
                }}
            >
                <Typography variant="h3">{t('firstPage.title')}</Typography>
            </Stepper>
            {firstContent ? (
                <Link href={`${asPath}/${firstContent.id}`} sx={{ my: 5 }} underline="hover">
                    {t('firstPage.firstParagraphLink')}
                </Link>
            ) : null}
        </Box>
    );
};

export default FirstPage;
